var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"scale-wrapper",style:(("width: " + _vm.$pageWidth + "px; height: " + _vm.$pageHeight + "px; transform: scale(" + _vm.scaleWidth + ", " + _vm.scaleHeight + ")"))},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }